import ApplicationModel, { attr } from '../ApplicationModel';
import { type IdeaCategorizationAttributes } from './generated/IdeaCategorizationAttributes';
import { model } from '../modelBuilder';

interface IdeaCategorization extends IdeaCategorizationAttributes {}

@model
class IdeaCategorization extends ApplicationModel {
  // Start auto-generated
  static typename: 'IdeaCategorization' = 'IdeaCategorization';
  get typename(): 'IdeaCategorization' {
    return 'IdeaCategorization';
  }

  static internalTypename: 'Ideas::IdeaCategorization' =
    'Ideas::IdeaCategorization';
  get internalTypename(): 'Ideas::IdeaCategorization' {
    return 'Ideas::IdeaCategorization';
  }

  static fields = {
    id: attr({ readable: true }),
    ideaCategoryId: attr({ readable: true }),
    ideaId: attr({ readable: true }),
    idea: attr.belongsTo({ readable: true, typename: 'Idea' }),
    ideaCategory: attr.belongsTo({ readable: true, typename: 'IdeaCategory' }),
    bookmarksRecordPositions: attr.hasMany({
      args: { filters: 'RecordPositionFilters' },
      readable: true,
    }),
  };
  // End auto-generated
}

export default IdeaCategorization;
